import { render, staticRenderFns } from "./VehicleTrim.vue?vue&type=template&id=5f965c51&scoped=true&"
import script from "./VehicleTrim.vue?vue&type=script&lang=js&"
export * from "./VehicleTrim.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTrim.vue?vue&type=style&index=0&id=5f965c51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f965c51",
  null
  
)

export default component.exports